import queryString from 'query-string';
import { useParams } from 'react-router-dom';

import { GenericTable, Spinner, useApiQuery } from '@/modules/common';
import { EventSms } from '@/modules/eventsV2/types';

import { getSmsHistoryColumns } from './columns';
import { TableFilters } from './components';
import { useEventFilters } from "@/modules/eventsV2/hooks";

export const SmsHistoryTab = () => {
  const params = useParams<{ id: string }>();

  const { filters, filtersChange } = useEventFilters();

  const { data: smsHistoryData, isFetching } = useApiQuery<{
    items: EventSms[];
  }>(
    `/events/${params.id}/sms-history?${queryString.stringify({
      searchText: filters.search,
      status: filters.status,
      date: filters.date,
    }, { arrayFormat: 'bracket' })}&pageSize=1000`,
    {
      queryKey: ['eventSmsHistory', params.id, filters],
      initialData: { items: [] },
      refetchInterval: 60000,
    }
  );

  const columns = getSmsHistoryColumns();

  if (isFetching) {
    return <Spinner />;
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="font-semibold text-lg">SMS Table</p>
      <div className="flex flex-col gap-4">
        <GenericTable<EventSms>
          columns={columns}
          name="event-sms-history"
          data={smsHistoryData.items || []}
          emptyCellClassName="h-20"
          sizeStyleProperty="minWidth"
          tableCellClassName="px-2 py-1"
          tableRowClassName="hover:bg-transparent"
          isFiltered={Object.keys(filters).length > 0}
          emptyTitle="No sms yet"
          emptyDescription=""
          tableFilterClassName="flex-wrap justify-start mb-4"
        >
          <TableFilters filters={filters} onFilters={filtersChange} />
          <p className="text-xs text-zink-400 w-full flex-shrink-1">
            All SMS: {smsHistoryData.items?.length || 0}
          </p>
        </GenericTable>
      </div>
    </div>
  );
};
